<template>
    <v-dialog v-model="bCardVisible" width="530px" content-class="overflow-y-hidden">
        <v-card>
            <v-card-title>{{ $t('membership.classes.title') }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="text--primary">
                <v-row class="mt-2">
                    <v-col>
                        <p>{{ $t("membership.classes.card_description", { memberName: membershipDataCard.name }) }}</p>
                        <p>
                            <span>{{ $t("membership.classes.class_name") }}</span>: {{ membershipDataCard.className }} <br />
                            <span>{{ $t("membership.classes.race_number") }}</span>: {{ membershipDataCard.raceNumber }} 
                        </p>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-row>
                    <v-col md="12" class="text-right">
                        <v-btn @click="close">{{ $t("viewRegistration.close") }}</v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from "vuex";

import { VDialog, VRow, VCol, VBtn, VCard, VCardText, VCardTitle, VDivider, VCardActions } from 'vuetify/lib';
export default {
    components: {
        VDialog, VRow, VCol, VBtn, VCard, VCardText, VCardTitle, VDivider, VCardActions
    },
    data()
    {
        return {
            cardDialog: true
        }
    },
    computed: {
        ...mapState({
            membershipDataCard: (state) => state.membershipCard.card,
            bCardVisible: (state) => state.membershipCard.bCardVisible
        })
    },
    methods: {
        printCard() {
            let contents = document.getElementById("printMe").innerHTML;
            document.body.color = "#FFF";
            let frame1 = document.createElement("iframe");
            frame1.name = "frame1";
            frame1.style.position = "absolute";
            frame1.style.top = "-10000000px";
            document.body.appendChild(frame1);

            let frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document: frame1.contentDocument;
            frameDoc.document.open();
            frameDoc.document.write(contents);
            frameDoc.document.close();
            setTimeout(function(){
                window.frames["frame1"].focus();
                window.frames["frame1"].print();
                document.body.removeChild(frame1);
            }, 500);
            return false;
        },
        close() {
            this.$store.dispatch("setCardVisbilityAction", false);
        },
    },
}
</script>